// /assets/protein-calculator.js  (no <script> tags in this file)
(function () {
  function $(id) { return document.getElementById(id); }

  const weightInput   = $('pc-weight');
  const errorEl       = $('pc-error');
  const btn           = $('pc-calc-btn');
  const resultWrap    = $('pc-result-wrap');
  const minEl         = $('pc-min');
  const maxEl         = $('pc-max');

  if (!weightInput || !btn || !resultWrap || !minEl || !maxEl) return;

  function format(n){
    // show whole numbers; else one decimal
    return (Math.abs(n - Math.round(n)) < 0.05) ? String(Math.round(n)) : n.toFixed(1);
  }

  function calc() {
    const lbs = parseFloat(weightInput.value);
    if (isNaN(lbs) || lbs < 1) {
      errorEl.style.display = 'block';
      resultWrap.style.display = 'none';
      return;
    }
    errorEl.style.display = 'none';

    // Protein range (per day): ~0.7–1.0 g per lb body weight
    const min = lbs * 0.7;
    const max = lbs * 1.0;

    minEl.textContent = format(min);
    maxEl.textContent = format(max);

    resultWrap.style.display = 'block';

    // optional: smooth scroll the result into view on mobile
    resultWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  btn.addEventListener('click', calc);

  // Press Enter in the input to calculate
  weightInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') calc();
  });
})();